import type { MarketId, MarketTemplate, MarketView } from '@ps/isp-web-services-types';
import type { TranslationTag } from '@ps/web-core-intl';
import type { MessageDescriptor } from 'react-intl';

import { isCompoundMarketTemplate } from '@swf/sports/utils/isCompoundMarketTemplate';
import { marketTemplateTranslationMap } from '@swf/sports/utils/marketTemplateTranslationMap';

export const getMarketName = (
  {
    template,
    markets
  }: {
    template: MarketTemplate;
    markets: Record<MarketId, MarketView>;
  },
  formatMessageFn: (translationValue: TranslationTag | MessageDescriptor) => string
) => {
  const isTemplateCompound = isCompoundMarketTemplate(template);
  const titleInTranslationMap =
    isTemplateCompound && marketTemplateTranslationMap[template.config.title];
  return isCompoundMarketTemplate(template)
    ? titleInTranslationMap
      ? formatMessageFn(titleInTranslationMap)
      : ''
    : markets[template.marketId].marketName;
};
